// utils/exportToExcel.js
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

const getNestedValue = (obj, path) => {
  return path.split('.').reduce((acc, part) => acc && acc[part] !== undefined ? acc[part] : '', obj);
};

// export const exportToExcel = (data, headers = null, fileName = 'data.xlsx') => {
//   if (!data || data.length === 0) return;

//   const worksheetData = headers
//     ? [
//         headers.map(h => h.label),
//         ...data.data.map(row => headers.map(h => getNestedValue(row, h.key)))
//       ]
//     : data;

//   const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

//   const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
//   const fileData = new Blob([excelBuffer], { type: 'application/octet-stream' });

//   saveAs(fileData, fileName);
// };

export const exportVerifiedToExcel = (csvString, fileName = "data.xlsx") => {
  if (!csvString) return;

  const blob = new Blob([csvString], {
    type: "text/csv;charset=utf-8;",
  });
  

  saveAs(blob, fileName);
};

export const exportToExcel = (data, headers = null, fileName = 'data.xlsx') => {
  if (!data || data.length === 0) return;

  // Determine the actual array to use
  const dataArray = data.data && Array.isArray(data.data) ? data.data : data;

  const worksheetData = headers
    ? [
        headers.map(h => h.label),
        ...dataArray.map(row => headers.map(h => getNestedValue(row, h.key)))
      ]
    : dataArray;

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

  const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  const fileData = new Blob([excelBuffer], { type: 'application/octet-stream' });

  saveAs(fileData, fileName);
};

